import { RENTAL_AREA_STATES_VALUE_ENABLED } from "@raiden/library/constants/rentalArea";
import { useApi } from "@raiden/library/hooks/useApi";
import generateApiUrl from "@raiden/library/libraries/utils/generateApiUrl";
import generateFrontUri from "@raiden/library/libraries/utils/generateFrontUrl";
import { useIntl } from "react-intl";
import Seo from "../../components/Seo";
import { CommunityHalls } from "../../containers/CommunityHalls";

/**
 * @typedef {object} Props
 * @property {any} [value]
 */
/**
 * @param {Props} props
 */
function Page(props) {
  const intl = useIntl();

  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/RentalArea").RentalArea[]>} */
  const { swrResponse: swrResponseRentalAreas } = useApi(
    generateApiUrl({
      id: "@api.rental_areas.viewAny",
      query: {
        fields: ["rental_area.covers"],
        state: [RENTAL_AREA_STATES_VALUE_ENABLED],
        per_page: 100,
      },
    }),
  );

  return (
    <>
      <Seo
        title={intl.formatMessage({ defaultMessage: "Les salles communales" })}
        description={intl.formatMessage({
          defaultMessage: "Réservez nos salles communales.",
        })}
        links={(locale) =>
          generateFrontUri({
            id: "@front.communityHalls",
            parameters: {
              locale,
            },
          })
        }
      />

      <CommunityHalls rentalAreasResponse={swrResponseRentalAreas} />
    </>
  );
}

export default Page;

/**
 * @typedef {import("../../types/Page").PageInitialProps & Props} InitialProps
 */
/**
 * @param {import("../../types/AppContext").PageContext} context
 * @returns {Promise<InitialProps>}
 */
Page.getInitialProps = async function (context) {
  /** @type {InitialProps} */
  const values = {};

  return values;
};
